export const checksInfo = {
    'RowingPoseCheckShinAngle': {
        'category': 'catch',
        'equipment_types': [
            'Erg',
            'Boat'
        ],
        'label': 'Shins angle',
        'selector': 'int_diap_deg',
        'default_kwargs': {
            'angle_limits': [
                -5,
                15
            ]
        }
    },
    'RowingPoseCheckForwardAngle': {
        'category': 'catch',
        'equipment_types': [
            'Erg',
            'Boat'
        ],
        'label': 'Forward Body Angle',
        'selector': 'int_diap_deg',
        'default_kwargs': {
            'angle_limits': [
                -32,
                -17
            ]
        }
    },
    'RowingPoseCheckElbowUnbentEnough': {
        'category': 'catch',
        'equipment_types': [
            'Erg',
            'Boat'
        ],
        'label': 'Elbows unbent',
        'selector': 'int_min_deg',
        'default_kwargs': {
            'min_elbow_angle': 160
        }
    },
    'RowingPoseCheckLaybackAngle': {
        'category': 'finish',
        'equipment_types': [
            'Erg',
            'Boat'
        ],
        'label': 'Layback body angle',
        'selector': 'int_diap_deg',
        'default_kwargs': {
            'angle_limits': [
                20,
                45
            ]
        }
    },
    'RowingPoseCheckLegStraightEnough': {
        'category': 'finish',
        'equipment_types': [
            'Erg',
            'Boat'
        ],
        'label': 'Legs are straight',
        'selector': 'int_min_deg',
        'default_kwargs': {
            'min_knee_angle': 164
        }
    },
    'RowingPoseCheckElbowBentEnough': {
        'category': 'finish',
        'equipment_types': [
            'Erg',
            'Boat'
        ],
        'label': 'Elbows bent enough',
        'selector': 'int_max_deg',
        'default_kwargs': {
            'max_elbow_angle': 85
        }
    },
    'RowingPoseCheckHandleHeight': {
        'category': 'finish',
        'equipment_types': [
            'Erg'
        ],
        'label': 'Handle height',
        'selector': 'int_diap_percent_torso',
        'default_kwargs': {
            'trunk_height_percent_limits': [
                30,
                75
            ]
        }
    },
    'RowingCheckDriveLegsSeparation': {
        'category': 'other',
        'equipment_types': [
            'Erg',
            'Boat'
        ],
        'label': 'Drive Legs&Back separation',
        'selector': 'int_diap_percent',
        'default_kwargs': {
            'legs_separation_percent_limits': [60, 100]
        }
    },
    'RowingCheckDriveArmsSeparation': {
        'category': 'other',
        'equipment_types': [
            'Erg',
            'Boat'
        ],
        'label': 'Drive Back&Arms separation',
        'selector': 'int_diap_percent',
        'default_kwargs': {
            'arms_separation_percent_limits': [40, 100]
        }
    },
    'RowingCheckRecoveryLegsSeparation': {
        'category': 'other',
        'equipment_types': [
            'Erg',
            'Boat'
        ],
        'label': 'Recovery Back&Legs separation',
        'selector': 'int_diap_percent',
        'default_kwargs': {
            'legs_separation_percent_limits': [40, 100]
        }
    },
    'RowingCheckRecoveryArmsSeparation': {
        'category': 'other',
        'equipment_types': [
            'Erg',
            'Boat'
        ],
        'label': 'Recovery Arms&Back separation',
        'selector': 'int_diap_percent',
        'default_kwargs': {
            'arms_separation_percent_limits': [40, 100]
        }
    },
    'RowingCheckDriveDurationPercent': {
        'category': 'other',
        'equipment_types': [
            'Erg',
            'Boat'
        ],
        'label': 'Drive duration',
        'selector': 'int_diap_percent',
        'default_kwargs': {
            'drive_duration_percent_limits': [30, 45]
        }
    },
    'RowingCheckStrokeRate': {
        'category': 'other',
        'equipment_types': [
            'Erg',
            'Boat'
        ],
        'label': 'Stroke rate',
        'selector': 'int_diap_spm',
        'default_kwargs': {
            'stroke_rate_limits': [
                17,
                24
            ]
        }
    }
}

export let checksSchema = {
    catch: [],
    finish: [],
    other: []
}

for (let checkName in checksInfo) {
    checksSchema[checksInfo[checkName].category].push(checkName)
}
